import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { movies } from '@/mocks/movies';

export default function RecommendSection() {
  const items = movies.filter((m) => !m.featured).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-md bg-primary-500 text-white flex items-center justify-center">
            <i className="ri-stack-line text-xl"></i>
          </span>
          <div>
            <p className="text-xs text-foreground-500 font-label uppercase tracking-widest">You May Also Like</p>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">相关影视推荐</h2>
          </div>
        </div>
        <Link
          to="/category"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
        >
          浏览全部影视 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {items.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}